type TimeBillingEntry = {
  readonly timeBilling?: { readonly is_locked: boolean } | null;
};

/**
 * Entry in a not yet locked Time Billing can't be changed, same as a locked entry.
 * API returns unlocked Time Billing first, so `timeBilling` is enough to decide.
 */
export function isInUnlockedTimeBilling(
  entry: TimeBillingEntry,
  isTimeBillingEnabled: boolean,
): boolean {
  return isTimeBillingEnabled && entry.timeBilling?.is_locked === false;
}
